import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfigProvider } from 'antd';
import classNames from 'classnames';
import { useContext } from 'react';
import { useStyle } from './style';

var GlobalFooter = function GlobalFooter(_ref) {
  var className = _ref.className,
      prefixCls = _ref.prefixCls,
      links = _ref.links,
      copyright = _ref.copyright,
      style = _ref.style;
  var context = useContext(ConfigProvider.ConfigContext);
  var baseClassName = context.getPrefixCls(prefixCls || 'pro-global-footer');

  var _useStyle = useStyle(baseClassName),
      wrapSSR = _useStyle.wrapSSR,
      hashId = _useStyle.hashId;

  if ((links == null || links === false || Array.isArray(links) && links.length === 0) && (copyright == null || copyright === false)) {
    return null;
  }

  return wrapSSR(_jsxs("div", {
    className: classNames(baseClassName, hashId, className),
    style: style,
    children: [links && _jsx("div", {
      className: "".concat(baseClassName, "-list ").concat(hashId),
      children: links.map(function (link) {
        return _jsx("a", {
          className: "".concat(baseClassName, "-list-link ").concat(hashId),
          title: link.key,
          target: link.blankTarget ? '_blank' : '_self',
          href: link.href,
          rel: "noreferrer",
          children: link.title
        }, link.key);
      })
    }), copyright && _jsx("div", {
      className: "".concat(baseClassName, "-copyright ").concat(hashId),
      children: copyright
    })]
  }));
};

export { GlobalFooter };